<template>
  <b-card class="metric-general">
    <small class="mb-2 float-right">
      {{ labels.surveyLink }}:
      <b id="survey-link" v-clipboard="() => surveyLink">{{ surveyLink }}</b>
      <b-tooltip target="survey-link">
        <div class="tooltip-info">
          {{ labels.copySurveyLink }}
        </div>
      </b-tooltip>
    </small>
    <p class="mb-0">
      {{ labels.generated }}<b>{{ createdAt }}</b>
    </p>
    <p>
      {{ labels.accessLevel }}<b>{{ accessLevel }}</b>
    </p>
    <div class="graph">
      <div class="chart">
        <PercentCircle
          :score="report.stats || { answered: 0, skipped: 0, no_answer: 0 }"
          :label1="resources.page.home.customPoll.completed"
        />
      </div>

      <div class="legend p-4">
        <span>{{ labels.statistics }}</span>
        <div class="wrap-flex">
          <span class="circle lima"></span>
          <span>{{ (labels.answered || '').toUpperCase() }}</span>
          <span>{{ (report.stats || {}).answered }}%</span>
        </div>
        <div class="wrap-flex">
          <span class="circle orange"></span>
          <span>{{ (labels.skipped || '').toUpperCase() }}</span>
          <span>{{ (report.stats || {}).skipped }}%</span>
        </div>
        <div class="wrap-flex">
          <span class="circle"></span>
          <span>{{ labels.notAnswered }}</span>
          <span>{{ (report.stats || {}).no_answer }}%</span>
        </div>
      </div>

      <b-card>
        <dl>
          <div>
            <dt>{{ labels.status }}</dt>
            <dd>
              {{ resources.page.home.customPoll.report.status[report.status] }}
            </dd>
          </div>

          <div>
            <dt>{{ labels.activatedAt }}</dt>
            <dd>{{ formatDate(report.createdAt) }}</dd>
          </div>

          <div>
            <dt>{{ labels.addressee }}</dt>
            <dd>{{ report.numEmployees }} {{ labels.users }}</dd>
          </div>

          <!-- <div>
            <dt>{{labels.public}}</dt>
            <dd>{{(report.groups || []).length}} {{labels.groups}}</dd>
          </div> -->

          <div>
            <dt>{{ labels.content }}</dt>
            <dd>{{ report.numQuestions }} {{ labels.questions }}</dd>
          </div>

          <div>
            <dt>{{ labels.createdBy }}</dt>
            <dd>{{ (report.owner || {}).name }}</dd>
          </div>
        </dl>
      </b-card>
    </div>
  </b-card>
</template>

<script>
import { mapGetters } from 'vuex'
import PercentCircle from '@/components/CustomPoll/PercentCircle.vue'

const props = {
  report: {
    type: Object,
    required: true,
  },
  surveyLink: {
    type: String,
    required: true,
  },
  scoreValue: null,
}
export default {
  components: {
    PercentCircle,
  },
  props,
  computed: {
    ...mapGetters({
      resources: 'resources',
    }),
    labels() {
      return this.resources.page.home.customPoll.report.generalMetric
    },
    createdAt: function() {
      return this.formatDate()
    },
    accessLevel: function() {
      return this.report.accessLevel === 'public'
        ? this.labels.open
        : this.labels.restricted
    },
  },
  methods: {
    formatDate: function(formatDate = undefined) {
      const [day, month, year] = this.$moment(formatDate)
        .format('DD/MMMM/YYYY')
        .split('/')
      const date = this.labels.date
      return date
        .replace('$day', day)
        .replace('$month', month)
        .replace('$year', year)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~@/styles/custom/colors';

.metric-general {
  font-size: 14px;

  #survey-link {
    cursor: pointer;
  }

  p,
  dt {
    color: map-get($theme-colors, 'gray03');
    font-weight: normal;
  }

  b,
  dd {
    color: map-get($theme-colors, 'gray04');
    font-weight: 500;
  }

  .graph {
    display: flex;
    justify-content: flex-end;

    @media (max-width: 426px) {
      flex-direction: column;
    }

    .chart {
      display: flex;
      justify-content: center;
      min-width: 30%;
    }

    .legend {
      align-items: flex-start;
      background: none;
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin-top: 10px;
      width: auto;
      min-width: 30%;

      .wrap-flex {
        align-items: center;
        display: flex;
        width: 100%;

        :nth-child(2) {
          flex-grow: 1;
        }
      }

      .circle {
        background: map-get($theme-colors, 'ciano02');
        border-radius: 30px;
        display: inline-block;
        height: 10px;
        width: 10px;
        margin-right: 5px;

        &.lima {
          background: map-get($theme-colors, 'lima');
        }

        &.orange {
          background: map-get($theme-colors, 'orange');
        }
      }

      div {
        font-weight: 500;
      }
    }

    .card {
      min-width: 40%;

      .card-body {
        padding: 1rem;
        display: flex;

        dl {
          display: flex;
          flex-flow: row wrap;
          margin: 0;

          div {
            width: 50%;
          }
        }
      }
    }
  }
}
</style>
